import { render, staticRenderFns } from "./ParentNotification.vue?vue&type=template&id=0b1a42e0"
import script from "./ParentNotification.vue?vue&type=script&lang=ts"
export * from "./ParentNotification.vue?vue&type=script&lang=ts"
import style0 from "./ParentNotification.vue?vue&type=style&index=0&id=0b1a42e0&prod&lang=less"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports